import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService } from 'primeng/api';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FarsiToEnglishInterceptor } from './interceptors/farsiToEnglish.interceptor';
import { ToastComponent } from './components/toast/toast.component';
import { LoadingComponent } from './components/loading/loading.component';
import {NgxsModule} from "@ngxs/store";
import {AccessState} from "./services/storage/ngx/actions";
import { VideoUploaderComponent } from './components/video-uploader/video-uploader.component';
import {AfraAuthComponent} from "./components/afra-auth/afra-auth.component";

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastComponent,
    LoadingComponent,
    NgxsModule.forRoot([AccessState])
  ],
  providers: [
    MessageService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FarsiToEnglishInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
